import React, { useEffect } from 'react';
import classNames from 'classnames';
import Icon from '../../assets/icons/Icon';

const CustomRadioButton = (props) => {
    const {
        input: { onChange, checked, name, value },
        label,
        defaultChecked,
        disabled,
        className,
        meta: { touched, error },
        submit,
        'data-cy': dataCy,
        topLabelClassName,
        labelClassName,
        divClassName
    } = props;

    const RadioButtonClass = classNames({
        'radio-btn': true,
        disabled,
    });

    useEffect(() => {
        if (defaultChecked) {
            onChange(value);
        }
    }, []);

    return (
        <div className={`form__form-group-input-wrap ${divClassName}`}>
            <label
                className={`${RadioButtonClass}${
                    className ? ` radio-btn--${className} ${topLabelClassName}` : `${topLabelClassName}`
                }`}
                data-cy={dataCy}
            >
                <input
                    className="radio-btn__radio"
                    name={name}
                    id={name}
                    type="radio"
                    onChange={() => onChange(value)}
                    checked={checked}
                    disabled={disabled || submit}
                />
                <span className="radio-btn__radio-custom" />
                {className === 'button' ? (
                    <span className="radio-btn__label-svg">
                        <Icon icon="Check" className="radio-btn__label-check" />
                        <Icon
                            icon="Close"
                            className="radio-btn__label-uncheck"
                        />
                    </span>
                ) : (
                    ''
                )}
                <span className={`radio-btn__label ${labelClassName}`}>
                    {label}
                </span>
            </label>
            {touched && error && (
                <span
                    className="form__form-group-error"
                    style={{ marginBottom: '1%' }}
                >
                    {error}
                </span>
            )}
        </div>
    );
};

CustomRadioButton.defaultProps = {
    label: '',
    defaultChecked: false,
    disabled: false,
    className: '',
    submit: false,
    'data-cy': undefined,
};

export default CustomRadioButton;
